import {
  createSelector,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export interface PatientHeaderState {
  isHeaderCollapsed?: boolean;
  headerAnimationInProgress?: string;
}

const initialState: PatientHeaderState = {
  isHeaderCollapsed: undefined,
  headerAnimationInProgress: "",
};

export const patientHeaderSlice = createSlice({
  name: "patient-header",
  initialState,
  reducers: {
    setHeaderAnimationInProgress: (state, action: PayloadAction<string>) => {
      state.headerAnimationInProgress = action.payload;
    },
    setIsHeaderCollapsed: (
      state,
      action: PayloadAction<boolean | undefined>,
    ) => {
      state.isHeaderCollapsed = action.payload;
    },
  },
});

export const { setHeaderAnimationInProgress, setIsHeaderCollapsed } =
  patientHeaderSlice.actions;

const patientHeaderSelector = (state: RootState) => state.patientHeader;

export const selectIsHeaderCollapsed = createSelector(
  patientHeaderSelector,
  (patientHeader) => patientHeader.isHeaderCollapsed,
);

export const selectHeaderAnimationInProgress = createSelector(
  patientHeaderSelector,
  (patientHeader) => patientHeader.headerAnimationInProgress,
);

export default patientHeaderSlice.reducer;
